<template>
  <div class="tableFixHead mt-4">
    <table class="table table-striped table-bordered container-custom"
    >
      <thead>
      <tr>
        <th
            v-for="(item, index) in listTitle"
            :key="index"
        >
          {{ item }}
            <span
                v-if="isShowIconsSort"
                class="icon__sort icon__sort__asc"
                @click="handleSort(item)"
            >▲</span>
            <span
                v-if="isShowIconsSort"
                class="icon__sort icon__sort__desc"
                @click="handleSort(item)"
            >▼</span>
        </th>
      </tr>
      </thead>
      <tbody v-if="listData.length > 0" class="section-table-contents__container">
      <tr
          v-for="(item, index) in listData"
          :key="index"
      >
        <td>
          <input
              v-if="!isSelectRadio && index !== listData.length-1"
              v-model="item.isSelect"
              :disabled="item.isDisable"
              @change="handleChangeCheckbox(item)"
              type="checkbox"
              class="input__cursor focusable fist-checkbox"
              @keydown.tab.prevent="handleTabNextSection(item)"
              :data-sn-left="toClassLastItem"
              :data-sn-right="toClassLastItem"
              :class="[classKeyboardCheckbox, classFirstItem]"
          />
          <input
              v-if="!isSelectRadio && index === listData.length-1"
              v-model="item.isSelect"
              :disabled="item.isDisable"
              @change="handleChangeCheckbox(item)"
              type="checkbox"
              :data-sn-down="classKeyboardLastCheckbox"
              :data-sn-left="toClassFirstItem"
              :data-sn-right="toClassFirstItem"
              class="input__cursor focusable last-checkbox"
              @keydown.tab.prevent="handleTabNextSection"
              :class="[classKeyboardCheckbox, classLastItem]"
          />
          <input
              v-if="isSelectRadio && index !== listData.length-1"
              :value="item.isSelect"
              @change="handleChangeRadioCheckbox(item)"
              :checked="item.isSelect"
              :data-sn-left="toClassLastItem"
              :data-sn-right="toClassLastItem"
              type="radio"
              name="isSelectLottery"
              class="input__cursor focusable first-checkbox-radio"
              @keydown.tab.prevent="handleTabNextSection"
              :class="classFirstItem"
          />
          <input
              v-if="isSelectRadio && index === listData.length-1"
              :value="item.isSelect"
              @change="handleChangeRadioCheckbox(item)"
              :checked="item.isSelect"
              v-model="item.isSelect"
              :data-sn-left="toClassFirstItem"
              :data-sn-right="toClassFirstItem"
              :data-sn-down="classKeyboardLastCheckbox"
              type="radio"
              name="isSelectLottery"
              class="input__cursor focusable first-checkbox-radio"
              @keypress.tab.prevent="handleTabNextSection"
              :class="classLastItem"
          />
        </td>
        <td v-if="item.lottery">{{  item.lottery  }}</td>
        <td v-if="item.name">{{  item.name }}</td>
        <td v-if="item.cutoff">{{  $filters.formatDate(item.cutoff) }}</td>
        <td v-if="item.market">{{  item.market  }}</td>
        <td v-if="item.nextDraw">{{  item.nextDraw  }}</td>
      </tr>
      </tbody>
    </table>
    <div
        class="section-table-contents__null"
        v-if="listData.length === 0"
    >
      Make your lottery selection.
    </div>
  </div>
</template>

<script>
export default {
  props: {
    listData: {
      type: Array,
      default: () => []
    },
    listTitle: {
      type: Array,
      default: () => []
    },
    isSelectRadio: {
      type: Boolean,
      default: false
    },
    isShowIconsSort: {
      type: Boolean,
      default: false
    },
    classKeyboardCheckbox: {
      type: String,
      default: ''
    },
    classKeyboardLastCheckbox: {
      type: String,
      default: ''
    },
    classLastItem: {
      type: String,
      default: ''
    },
    classFirstItem: {
      type: String,
      default: ''
    },
    toClassLastItem: {
      type: String,
      default: ''
    },
    toClassFirstItem: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dataSearch: '',
      isAsc: false,
    }
  },
  methods: {
    handleSort(item) {
      if(this.isAsc) {
        this.isAsc = false;
        this.$emit('sortAsc', item);
      } else {
        this.isAsc = true;
        this.$emit('sortDesc', item);
      }
    },
    handleTabNextSection() {
      this.$emit('tabNextSection');
    },
    handleChangeRadioCheckbox(data) {
      this.$emit('changeRadioCheckbox', {data});
    },
    handleChangeCheckbox(data) {
      this.$emit('changeCheckbox', {data});
    }
  }
}
</script>

<style scoped lang="scss" src="@/assets/scss/retail/section-search-select.scss"/>
